import { ListItemIconClassKey } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";

export const MuiListItemOverrides: Partial<
  OverridesStyleRules<ListItemIconClassKey, {}>
> = {
  root: {
    paddingLeft: 0,
    paddingRight: 0,
  
    "& .MuiListItemText-primary": {
      color: "#000000",
      fontSize: 16,
    },

    "& .MuiListItemText-secondary": {
      color: "#4d4d4d",
    },
  },
};
